import StoriesUserCommentedOn from "%/dynamic-component-editor/standard-pages/commented-stories-page/StoriesUserCommentedOn.vue";
import LegacyEntity from "%/dynamic-component-editor/classes/LegacyEntity";

export default class LegacyCommentedStories extends LegacyEntity {
  get elements() {
    return {
      StoriesUserCommentedOn,
    };
  }
}
